import { guidelineList } from "../../../utils/guidelines";
import React, { useEffect, useRef } from "react";
import styles from "./GuidelineTablesAndFigures.module.scss";
import TabGroup from "../../../components/TabGroup/TabGroup";
import { tablesAndFiguresTabs } from "./tablesAndFiguresTabs";
import { useNavigate } from "react-router-dom";
import CounterApp from "../../counter/CounterApp";
import { useDispatch, useSelector } from "react-redux";
import { selectDitaPath, setGuideline } from "../../counter/counterSlice";
import PropTypes from "prop-types";

const GuidelineTablesAndFigures = ({ glPage }) => {
  const navigate = useNavigate();
  const refInfo = useRef(null);
  const [glObject, setGlObject] = React.useState(null);
  const [tabs] = React.useState(tablesAndFiguresTabs);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setGuideline({ search: `&guidelinePage=${glPage}` }));
  }, [glPage]);

  useEffect(() => {
    const glObj = guidelineList.find((guideline) => {
      return guideline.onClickProps.replaceAll(" ", "_") === glPage;
    });
    setGlObject(glObj);
  }, [glPage]);

  const handleViewGuidelineClick = (e) => {
    if (!glObject) return;
    e.stopPropagation();
    navigate(`/guidelines/${glObject.onClickProps.replaceAll(" ", "_")}`);
  };

  const handleBackClick = (e) => {
    e.stopPropagation();
    navigate("/resources/tables-and-figures");
  };

  const ditapath = useSelector(selectDitaPath);

  return (
    <div className={styles.content}>
      <div className={styles.guidelineHeader}>
        <div className={styles.leftContent}>
          <button
            type="button"
            className={styles.backButton}
            data-testid="arrowButton"
            onClick={handleBackClick}
          >
            <i className={"fa tg-icons-RightArrow"}></i>
          </button>
          <span className={styles.guidelineTitle}>{glObject?.linkText}</span>
        </div>
        <button
          type="button"
          className={styles.viewGuidelineButton}
          data-testid="viewGuideline"
          onClick={handleViewGuidelineClick}
        >
          View guideline
          <i className={"tg-icons-Carat"}></i>
        </button>
      </div>
      <div className={styles.tabs}>
        {tabs && (
          <TabGroup
            key={tabs.map((t) => t.id).join("-")}
            tabs={tabs}
            defaultId={tabs[0].id}
            alignLeft={true}
          />
        )}
      </div>
      {ditapath && (
        <div id="tg_toc_id" className={"d-none"}>
          <CounterApp glPage={glPage} ref={refInfo} />
          <span className="username"></span>
        </div>
      )}
    </div>
  );
};

GuidelineTablesAndFigures.prototype = {
  glPage: PropTypes.string.isRequired,
};
export default GuidelineTablesAndFigures;
